import React from "react";
import { View } from "react-native";
import StyledText from "./ui/styled-text";

interface ErrorDisplayProps {
  message: string;
}

export function ErrorDisplay({ message }: ErrorDisplayProps) {
  return (
    <View className="flex-1 justify-center items-center max-sm:p-4">
      <View className="p-4 bg-red-100 border border-red-400 rounded">
        <StyledText className="text-red-700">{message}</StyledText>
      </View>
    </View>
  );
}
